import React from 'react';
import PropTypes from 'prop-types';
import AddressBook from '@medflex/components/stories/AddressBook';

const EmptyStateModule = ({ sort, onClick }) => {
  switch (sort) {
    case 'all':
    case undefined:
      return <AddressBook.EmptyStateAll />;
    case 'staff':
      return <AddressBook.EmptyStateTeam onClick={() => onClick('staff_type')} />;
    case 'physicians':
      return <AddressBook.EmptyStatePhysicians onClick={() => onClick('invitePhysician')} />;
    case 'patients':
      return <AddressBook.EmptyStatePatients onClick={() => onClick('email', 'invitePatient')} />;
    case 'groups':
      return <AddressBook.EmptyStateGroups onClick={() => onClick('sessionChatCreate')} />;
    case 'archive':
      return <AddressBook.EmptyStateArchive />;
    case 'invited':
      return (
        <AddressBook.EmptyStatePatientsInvited onClick={() => onClick('email', 'invitePatient')} />
      );
    default:
      return null;
  }
};

EmptyStateModule.propTypes = {
  sort: PropTypes.oneOf(['all', 'staff', 'physicians', 'patients', 'groups', 'archive', 'invited']),
  onClick: PropTypes.func,
};

export default EmptyStateModule;
